import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material';
interface Props {
	i18n: any;
	children: React.ReactNode;
}
const ConfigProvider = (props: Props) => {
	const { i18n, children } = props;

	return (
		<ThemeProvider
			theme={createTheme({
				direction: i18n.dir(),
			})}
		>
			{children}
		</ThemeProvider>
	);
};

export default ConfigProvider;
